<template>
<div class="row row-cols-1 row-cols-lg-5 g-0 p-0 m-0 mt-1">
	<div class="col px-0">
		<!-- Output current -->
		<div class="row m-0 me-1">
			<div class="half-transparent-border widget-7x5">
				<iout-chart
					:value="station.getFormatedMetric(PowerUnit.metricKeys.iOut, 'power', 1)"
					:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				/>
			</div>
		</div>
	</div>
	<div class="col px-0">
		<!-- Output voltage -->
		<div class="row m-0 me-1">
			<div class="half-transparent-border widget-7x5">
				<uout-chart
					:value="station.getFormatedMetric(PowerUnit.metricKeys.uOut, 'power', 1)"
					:style="station.power_unit.isConnect ? '' : 'filter: grayscale(100%);'"
				/>
			</div>
		</div>
	</div>
	<div class="col px-0">
		<!-- Output potential -->
		<div class="row m-0 me-1">
			<div class="half-transparent-border widget-7x5">
				<uprotect-chart
					:value="uProtect"
					:style="
						station.uProtectSource == 'power' ? 
							station.power_unit.isConnect ? '' : 'filter: grayscale(100%);' :
							station.uProtectSource == 'service' ? 
								station.service_unit.isConnect ? '' : 'filter: grayscale(100%);' :
									'filter: grayscale(100%);'
					"
				/>
			</div>
		</div>
	</div>
	<div class="col px-0 pe-1">
		<tile-vidget
			title="Захисний потенціал, 10&nbsp;хв"
			class="h-100 w-100 m-0"
			:style="station.service_unit.isConnect ? '' : 'filter: grayscale(100%);'"
			style="margin: 0 !important;"
		>
			<div class="row m-0 mt-3 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emin</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ station.getFormatedMetric('Uprotect_min', 'service', 2) }}</div>
			</div>
			<div class="row m-0 p-0 my-2">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Emax</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ station.getFormatedMetric('Uprotect_max', 'service', 2) }}</div>
			</div>
			<div class="row m-0 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Eavg</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ station.getFormatedMetric('Uprotect_avg', 'service', 2) }}</div>
			</div>
		</tile-vidget>
	</div>
	<div class="col px-0">
		<tile-vidget
			title="Значення потенціалу при вимкненному УКЗ"
			class="h-100 w-100 m-0"
			style="margin: 0 !important;"
		>
			<div class="row m-0 p-0 mt-auto">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">
					Eavg
				</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">
					{{ station.getFormatedMetric('off_station_potential_avg', 'service', 2) }}
				</div>
			</div>
			
			<div class="row m-0 mb-2 p-0 mt-auto">
				<div class="col-1 mx-0 ps-2 pe-1 text-start metric-name-text">
					Час
				</div>
				<div class="col-11 mx-0 pe-2 ps-1 text-end">
					{{ stationMetricTime('off_station_potential_avg', 'service') }}
				</div>
			</div>
		</tile-vidget>
	</div>
</div>

<div class="row g-0 mt-3 p-0">
	<div class="fs-6">Пов'язані КВП</div>
	<related-posts-table
		:stationId="stationId"
		@posts="(v) => posts = v"
	/>
</div>

<!-- Graph period choose -->
<div class="row g-0 m-0 mt-3 p-0">
	<div class="col g-0">
	<pick-period-vidget
		:tiles="new Array(
			['30 днів', 30],
			['90 днів', 90],
			['1 рік', 365],
			['2 роки', 365*2],
			['5 років', 365*5],)"
		@currentTile="(tile) => { potentialChartPeriodFrom = subtractHoursFromNowDate(tile[1] * 24); }"
	/>
	</div>
</div>
<div class="row g-0 m-0 p-0">
	<div class="col g-0 m-0 mt-1 p-0 half-transparent-border full-width-widget">
		<station-post-potentials-chart
			:stationId="stationId"
			:posts="posts"
			:time-from="potentialChartPeriodFrom"
			:time-to="potentialChartPeriodTo"
		/>
	</div>
</div>
</template>


<script>
import TileVidget from "@/components/Vidgets/TileVidget"
import UprotectChart from '@/components/Charts/UprotectChart.vue'
import IoutChart from '@/components/Charts/IoutChart.vue'
import UoutChart from '@/components/Charts/UoutChart.vue'
import StationPostPotentialsChart from '@/components/Charts/StationPostPotentialsChart.vue'
import RelatedPostsTable from "./RelatedPostsTable.vue"
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import { INFLUXDB } from '@/api/api.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { subtractHoursFromNowDate } from '@/helpers.js'

export default {
	UPDATE_TIME_TO_INTERVAL: 10000,

	components: {
		TileVidget,
		UprotectChart,
		IoutChart,
		UoutChart,
		StationPostPotentialsChart,
		RelatedPostsTable,
		PickPeriodVidget,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			INFLUXDB,
			Station,
			PowerUnit,
			subtractHoursFromNowDate,
			accountStore,
			stationsStore,
		}
	},

	data() {
		return {
			// For graph period from Date
			potentialChartPeriodFrom: new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 30)),
			potentialChartPeriodTo: new Date(),
			//updateTimeToInterval: null,
			// Related posts
			posts: [],
		}
	},

	created() {
		// this.updateTimeToInterval = setInterval(() => {
		// 	this.potentialChartPeriodTo = new Date()
		// }, this.$options.UPDATE_TIME_TO_INTERVAL)
	},

	methods: {
		stationMetricTime(metricName, unit="any") {
			let metric = this.station?.getMetric(metricName, unit)
			
			if (typeof metric == 'object') {
				return metric.time.toLocaleString()
			} else {
				return '-'
			}

		},
	},

	computed: {
		station() {return this.stationsStore.station(this.stationId) },

		uProtect() {
			switch(this.station.uProtectSource) {
				case null:
					return undefined
				case 'power': {
					const metric = this.station?.getMetric(PowerUnit.metricKeys.eOut, 'power')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				case 'service': {
					const metric = this.station?.getMetric(ServiceUnit.metricKeys.eAvg, 'service')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				default:
					return undefined
			}
		},
	},

	beforeUnmount() {
		// clearInterval(this.updateTimeToInterval)
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style scoped>
</style>